/**
 * Faz 8 (finans ve analitik) panel metinleri — Türkçe. `admin.tr.ts`'e tek satırla eklenir; paralel geliştirmede
 * birleştirme çakışması bu dosyada kalır (ADR-801).
 */
export const adminFaz8Tr = {
  reports: {
    navGroup: 'Raporlar ve satın alma',
    period: 'Dönem',
    presets: {
      this_month: 'Bu ay',
      last_month: 'Geçen ay',
      last_7: 'Son 7 gün',
      last_30: 'Son 30 gün',
      last_90: 'Son 90 gün',
      this_year: 'Bu yıl',
      last_year: 'Geçen yıl',
      custom: 'Özel aralık',
    },
    from: 'Başlangıç',
    to: 'Bitiş',
    interval: 'Gruplama',
    intervals: { day: 'Gün', week: 'Hafta', month: 'Ay', year: 'Yıl' },
    all: 'Tümü',
    csv: 'CSV indir',
    xlsx: 'Excel indir',
    print: 'Yazdır / PDF',
    printedAt: 'Yazdırma: {{date}}',
    vsNamed: '{{name}}: {{value}}',
    vsPrevious: 'Önceki dönem: {{value}}',
    deltaUp: '%{{pct}} artış',
    deltaDown: '%{{pct}} düşüş',
    deltaFlat: 'Değişim yok',
    deltaNew: 'Önceki dönemde yoktu',
    partial: 'Dönem henüz bitmedi; bugünün rakamları gün içinde değişebilir.',
    currencyNote:
      'Tutarlar TL. Döviz siparişler sipariş anındaki TCMB döviz alış kuruyla çevrilir; iade ve iptaller siparişin verildiği döneme yazılır.',
    empty: 'Bu dönemde veri yok.',
    none: 'Tanımsız',
    loadingAgain: 'Güncelleniyor…',
    chartEmpty: 'Grafikte gösterilecek satış yok.',
    tooltip: '{{bucket}}: {{value}}',
    dashboard: {
      noPermission: 'Satış rakamlarını görmek için satış raporları yetkisi gerekir.',
      tilesLabel: 'Satış özeti',
      today: 'Bugün net satış',
      todayOrders: 'Bugün sipariş',
      yesterday: 'Dün',
      last30: 'Son 30 gün net satış',
      last30Orders: 'Son 30 gün sipariş',
      chartTitle: 'Son 30 gün: günlük net satış (KDV dahil)',
      open: 'Satış raporunu aç',
    },
    share: 'Pay',
  },
  salesReport: {
    tilesTitle: 'Dönem özeti',
    navLabel: 'Satış raporu',
    store: 'Mağaza',
    channel: 'Kanal',
    segment: 'Müşteri türü',
    channels: { web: 'Web mağazası', b2b: 'Bayi portalı', manual: 'Panelden sipariş', api: 'API' },
    segments: { retail: 'Perakende', dealer: 'Bayi' },
    tiles: {
      netSales: 'Net satış',
      orders: 'Sipariş',
      averageOrder: 'Ortalama sepet',
      deductions: 'İade ve iptal',
      newCustomers: 'Yeni müşteri',
    },
    chartTitle: 'Net satış (KDV dahil)',
    summaryTitle: 'Brütten nete',
    rows: {
      productGross: 'Ürün brüt satışı (indirim öncesi)',
      discounts: 'İndirimler',
      shipping: 'Kargo ve kapıda ödeme geliri',
      orderTotal: 'Sipariş tutarı',
      cancellations: 'İptal edilen tutar',
      refunds: 'İade edilen tutar',
      deductions: 'İade ve iptal düşümü',
      netSales: 'Net satış (KDV dahil)',
      tax: 'KDV',
      netSalesExVat: 'Net satış (KDV hariç)',
      itemsSold: 'Satılan ürün adedi',
      cancelledOrders: 'Tamamen iptal edilen sipariş',
      customers: 'Sipariş veren müşteri',
      returningCustomers: 'Tekrar eden müşteri',
      newCustomerNetSales: 'Yeni müşterilerden net satış',
      returningCustomerNetSales: 'Tekrar edenlerden net satış',
    },
    thisPeriod: 'Bu dönem',
    previousPeriod: 'Önceki dönem',
    deductionNote:
      'İade ve iptal düşümü, iptal edilen ve iade edilen tutardan büyük olanıdır: ödenmiş siparişin iptali önce iade gerektirdiği için ikisi toplanmaz.',
    seriesTitle: 'Dönem tablosu',
    columns: {
      bucket: 'Dönem başı',
      orders: 'Sipariş',
      orderTotal: 'Sipariş tutarı',
      deductions: 'İade ve iptal',
      netSales: 'Net satış',
      netSalesExVat: 'KDV hariç',
      averageOrder: 'Ortalama sepet',
      name: 'Ad',
      quantity: 'Adet',
    },
    total: 'Toplam',
    awaiting: '{{count}} sipariş ({{amount}}) ödeme bekliyor; ödeme gelince satışa sayılır.',
    fxMissing: '{{count}} döviz siparişi için kur bulunamadı; bu siparişler rapora alınmadı.',
    breakdownTitle: 'Kırılım',
    breakdown: 'Kırılım türü',
    breakdowns: {
      product: 'Ürün',
      variant: 'Seçenek (SKU)',
      category: 'Kategori',
      brand: 'Marka',
      country: 'Ülke',
      channel: 'Kanal',
      store: 'Mağaza',
      segment: 'Müşteri türü',
      paymentMethod: 'Ödeme yöntemi',
    },
    categoryNote:
      'Birden çok kategorideki ürün her kategorisine yazılır; kategorilerin toplamı genel toplamı aşabilir. Pay, genel toplama göredir.',
    lineNote:
      'Ürün kırılımı KDV dahil satır tutarlarından, iptal edilen adetler düşülerek ve siparişin iadesi oranında azaltılarak hesaplanır; kargo geliri dahil değildir.',
    showing: '{{shown}} / {{total}} satır gösteriliyor; tamamı dosyada.',
  },
  financeInputs: {
    navLabel: 'Finans girdileri',
    section: 'Bölüm',
    sections: {
      fees: 'Ödeme komisyonları',
      shipments: 'Kargo maliyetleri',
      shippingRules: 'Kargo tahmin kuralları',
      expenses: 'İşletme giderleri',
    },
    readOnly: 'Bu bilgileri görebilirsiniz; değiştirmek için finans girdilerini yönetme yetkisi gerekir.',
    providers: {
      iyzico: 'iyzico (kart)',
      paytr: 'PayTR (kart)',
      bank_transfer: 'Havale/EFT',
      cash_on_delivery: 'Kapıda ödeme',
      open_account: 'Açık hesap (cari)',
      manual: 'Elle (havale/nakit vb.)',
    },
    provider: 'Ödeme yöntemi',
    installments: 'Taksit',
    allInstallments: 'Diğer bütün taksitler',
    installmentN: '{{n}} taksit',
    singlePayment: 'Tek çekim',
    rate: 'Oran (%)',
    fixedFee: 'İşlem başına sabit ücret',
    validFrom: 'Geçerlilik başı',
    validTo: 'Geçerlilik sonu',
    openEnded: 'Süresiz',
    note: 'Not',
    addFeeRule: 'Komisyon kuralı ekle',
    editFeeRule: 'Komisyon kuralını düzenle',
    saveFeeRule: 'Kuralı kaydet',
    feeRuleSaved: 'Komisyon kuralı kaydedildi.',
    feeRuleDeleted: 'Komisyon kuralı silindi.',
    confirmDeleteFee: 'Bu komisyon kuralı silinsin mi? Finans raporundaki hesaplanan komisyon değişir.',
    emptyFees: 'Komisyon kuralı yok',
    emptyFeesLead:
      'Ödeme kuruluşunuzun sözleşmesindeki oranları girin. Kural girilene kadar finans raporunda komisyon "veri yok" görünür.',
    rateInvalid: 'Oranı 0 ile 50 arasında yazın (ör. 2,49).',
    amountInvalid: 'Tutarı yazın (ör. 125,50).',
    filter: 'Gösterilen',
    filters: { all: 'Bütün gönderiler', missing: 'Maliyeti girilmemiş', entered: 'Maliyeti girilmiş' },
    carrier: 'Kargo firması',
    allCarriers: 'Bütün firmalar',
    shipmentsSummary:
      '{{shipments}} gönderi · girilen maliyet (KDV dahil): {{entered}} ({{enteredCount}} gönderi) · tahmini (KDV hariç): {{estimated}} · maliyeti bilinmeyen: {{unknown}}',
    columns: {
      date: 'Tarih',
      order: 'Sipariş',
      carrier: 'Firma',
      tracking: 'Takip no',
      weight: 'Ağırlık',
      cost: 'Maliyet',
      source: 'Kaynak',
      provider: 'Ödeme yöntemi',
      installments: 'Taksit',
      rate: 'Oran',
      fixedFee: 'Sabit ücret',
      validity: 'Geçerlilik',
      maxWeight: 'En çok ağırlık',
      category: 'Kategori',
      description: 'Açıklama',
      amount: 'Tutar (KDV dahil)',
      vat: 'KDV',
      reference: 'Belge no',
      store: 'Mağaza',
    },
    estimated: 'tahmini, KDV hariç',
    unknownCost: 'bilinmiyor',
    sources: { manual: 'Elle', import: 'Dosyadan' },
    enterCost: 'Maliyet gir',
    editCost: 'Kargo maliyetini düzenle',
    newCost: 'Kargo maliyeti: {{tracking}}',
    amount: 'Tutar (KDV dahil)',
    vat: 'KDV tutarı',
    reference: 'Fatura / belge no',
    entryDate: 'Belge tarihi',
    saveCost: 'Maliyeti kaydet',
    costSaved: 'Kargo maliyeti kaydedildi.',
    costDeleted: 'Kargo maliyeti silindi.',
    confirmDeleteCost: 'Bu gönderinin kargo maliyeti silinsin mi?',
    emptyShipments: 'Bu dönemde gönderi yok',
    import: 'Kargo faturası yükle',
    importTitle: 'Kargo faturası dosyası',
    importLead:
      'CSV veya Excel dosyası: "Takip no" ve "Tutar" sütunları zorunlu; "KDV", "Fatura no" ve "Tarih" isteğe bağlı. Önce önizleme gösterilir, onaylayınca yazılır.',
    file: 'Dosya',
    preview: 'Önizle',
    apply: 'Eşleşenleri kaydet',
    overwrite: 'Maliyeti girilmiş gönderilerin tutarını dosyadakiyle değiştir',
    importSummary:
      '{{ready}} satır kaydedilmeye hazır · {{exists}} gönderinin maliyeti zaten var · {{errors}} satırda sorun',
    importApplied: '{{count}} gönderinin kargo maliyeti kaydedildi.',
    rowStatus: { ready: 'Hazır', exists: 'Zaten girilmiş', error: 'Sorun' },
    row: 'Satır',
    status: 'Durum',
    problem: 'Açıklama',
    addRule: 'Tahmin kuralı ekle',
    editRule: 'Tahmin kuralını düzenle',
    saveRule: 'Kuralı kaydet',
    ruleSaved: 'Tahmin kuralı kaydedildi.',
    ruleDeleted: 'Tahmin kuralı silindi.',
    confirmDeleteRule: 'Bu tahmin kuralı silinsin mi?',
    maxWeight: 'Paket başına en çok ağırlık (kg)',
    noLimit: 'Sınır yok',
    cost: 'Gönderi başına maliyet (KDV hariç)',
    emptyRules: 'Tahmin kuralı yok',
    emptyRulesLead:
      'Kargo firmanızın desi/kilo fiyat listesini girin; maliyeti girilmemiş gönderiler bu kurallarla "tahmini" hesaplanır.',
    kg: '{{kg}} kg',
    category: 'Kategori',
    allCategories: 'Bütün kategoriler',
    categories: {
      rent: 'Kira',
      salary: 'Maaş ve personel',
      marketing: 'Pazarlama (reklam dışı)',
      software: 'Yazılım ve abonelik',
      packaging: 'Ambalaj',
      logistics: 'Depo ve lojistik',
      utilities: 'Elektrik, su, internet',
      professional: 'Mali müşavir, hukuk, danışmanlık',
      tax_fees: 'Vergi ve harçlar',
      other: 'Diğer',
    },
    expenseDate: 'Tarih',
    description: 'Açıklama',
    store: 'Mağaza',
    noStore: 'Bütün işletme',
    addExpense: 'Gider ekle',
    editExpense: 'Gideri düzenle',
    saveExpense: 'Gideri kaydet',
    expenseSaved: 'Gider kaydedildi.',
    expenseDeleted: 'Gider silindi.',
    confirmDeleteExpense: 'Bu gider silinsin mi?',
    emptyExpenses: 'Bu dönemde gider yok',
    emptyExpensesLead:
      'Kira, maaş, yazılım gibi giderleri girin; finans raporunda net kâr ve nakit akışına yansır. Reklam harcaması reklam merkezinden gelir.',
    expensesTotal: 'Toplam: {{amount}} (KDV {{vat}})',
  },
  financeReport: {
    navLabel: 'Finans raporu',
    tiles: {
      revenue: 'Gelir (KDV hariç)',
      grossProfit: 'Brüt kâr',
      contribution: 'Katkı marjı',
      operatingProfit: 'Faaliyet kârı',
      netCash: 'Net nakit akışı',
    },
    marginOf: 'Gelire oranı: {{pct}}',
    grossUnknown: 'Maliyeti bilinmeyen satış var; brüt kâr olduğundan yüksek görünebilir.',
    pnlTitle: 'Kârlılık (sipariş esası, KDV hariç)',
    rows: {
      netSales: 'Net satış (KDV dahil)',
      revenue: 'Gelir (net satış, KDV hariç)',
      cogs: 'Satılan malın maliyeti (SMM)',
      grossProfit: 'Brüt kâr',
      shipping: 'Kargo gideri',
      fees: 'Ödeme komisyonu',
      ads: 'Reklam harcaması',
      disputes: 'Ödeme itirazı kaybı ve ücretleri',
      contribution: 'Katkı marjı',
      expenses: 'İşletme giderleri',
      operatingProfit: 'Faaliyet kârı',
    },
    statuses: { complete: 'Tam', partial: 'Kısmen', missing: 'Veri yok' },
    notes: {
      cogsUnknown:
        '{{amount}} satışın maliyeti bilinmiyor; brüt kâr olduğundan yüksek görünür. Maliyeti bilinen satırlarda brüt marj: {{pct}}.',
      cogsUnknownAll: '{{amount}} satışın maliyeti bilinmiyor; brüt kâr olduğundan yüksek görünür.',
      cogsLate: '{{amount}} maliyet sonradan alındı (tahmini).',
      shippingEstimated: '{{amount}} tahmin kuralıyla hesaplandı.',
      shippingUnknown: '{{count}} gönderinin maliyeti bilinmiyor (girilmedi, tahmin kuralı da yok).',
      feesUnknown: '{{count}} kart ödemesi için komisyon kuralı yok.',
      adsMissing: 'Reklam hesabı bağlı değil; reklam harcaması sıfır sayıldı.',
      adsFx: 'Bazı günlerin döviz reklam harcaması için kur bulunamadı.',
      disputes:
        'Kaybedilen veya kabul edilen {{count}} itiraz: {{lost}} (KDV dahil; mal geri gelmediği varsayılır) ve itiraz ücretleri {{fees}}.',
    },
    goInputs: 'Finans girdilerine git',
    pnlCols: { item: 'Kalem', amount: 'Tutar', share: 'Gelire oranı', status: 'Veri durumu' },
    expenseOf: 'Gider: {{name}}',
    cashFx: 'Kuru bulunamayan {{count}} döviz ödemesi nakit akışına katılmadı.',
    dealerCollectionsHidden:
      'Bayi tahsilatları işletme genelidir; mağaza, kanal veya perakende süzgecinde ve mağaza kapsamı sınırlı kullanıcıda gösterilmez.',
    inByMethod: 'Alınan ödeme: {{name}}',
    noData: 'Bu dönemde gösterilecek veri yok.',
    noProducts: 'Bu dönemde satılan ürün yok.',
    showingProducts: 'Gelire göre ilk {{count}} ürün gösteriliyor.',
    cashTitle: 'Nakit akışı (gerçekleştiği tarihe göre)',
    cashRows: {
      in: 'Nakit girişi',
      dealerCollections: 'Bayi tahsilatları (cari)',
      out: 'Nakit çıkışı',
      refunds: 'İadeler',
      fees: 'Ödeme komisyonu',
      shipping: 'Kargo ödemeleri (KDV dahil)',
      expenses: 'İşletme giderleri (KDV dahil)',
      ads: 'Reklam harcaması',
      suppliers: 'Tedarikçi ödemeleri',
      disputes: 'Ödeme itirazları (kaybedilen tutar ve ücret)',
      net: 'Net nakit akışı',
    },
    cashNote:
      'Yönetim amaçlı yaklaşık akış: banka hesabı mutabakatı değildir. Komisyon, ödeme kuruluşu kesintisinin kurallarla hesaplanan tutarıdır.',
    vatTitle: 'KDV özeti',
    vatRows: {
      output: 'Satışlarda hesaplanan KDV',
      inputExpenses: 'Giderlerde ödenen KDV',
      inputShipping: 'Kargo maliyetlerinde ödenen KDV',
      inputPurchases: 'Tedarikçi faturalarındaki KDV (mal alımı)',
      difference: 'Fark',
    },
    vatNote:
      "Mal alımı KDV'si mal kabulde oluşan tedarikçi faturalarından gelir. Beyanname yerine geçmez; mali müşavirinizle teyit edin.",
    balancesTitle: 'Alacaklar ve borçlar (bugün)',
    balanceRows: {
      dealerReceivables: 'Bayi alacakları (borçlu {{count}} bayi)',
      openDisputes: 'Açık ödeme itirazları — risk altındaki tutar ({{count}} itiraz)',
      codInTransit: 'Kargodaki kapıda ödeme tahsilatı ({{count}} sipariş)',
      supplierPayables: 'Tedarikçi borçları ({{count}} tedarikçi · vadesi geçen {{overdue}})',
    },
    dealerScopeHidden: 'Mağaza kapsamınız sınırlı olduğu için işletme geneli gösterilmez',
    openDisputesLink: 'İtirazları aç',
    feesTitle: 'Ödeme komisyonu (ödeme yöntemine göre)',
    feeCols: {
      provider: 'Ödeme yöntemi',
      processed: 'İşlem tutarı',
      fee: 'Komisyon',
      noRule: 'Kuralı olmayan ödeme',
    },
    productsTitle: 'Ürün kârlılığı',
    productCols: {
      product: 'Ürün',
      revenue: 'Gelir (KDV hariç)',
      cogs: 'SMM',
      grossProfit: 'Brüt kâr',
      margin: 'Marj',
    },
    unknownCost: 'maliyet bilinmiyor',
    estimatedCost: 'tahmini maliyet',
    channelsTitle: 'Kanal kârlılığı',
    channelCols: {
      channel: 'Kanal',
      revenue: 'Gelir',
      cogs: 'SMM',
      shipping: 'Kargo',
      fees: 'Komisyon',
      contribution: 'Katkı (reklam hariç)',
    },
    reconTitle: 'Ödeme mutabakatı',
    reconCols: { provider: 'Sağlayıcı', status: 'Son mutabakat', finished: 'Tarih', open: 'Çözülmemiş fark' },
    reconStatus: { running: 'Sürüyor', ok: 'Uyumlu', mismatch: 'Fark var', error: 'Hata' },
    reconEmpty: 'Henüz mutabakat yapılmadı.',
    openPayments: 'Ödemeler ekranına git',
    missingTitle: 'Maliyeti girilmemiş satılan ürünler',
    missingLead:
      'Bu dönemde satılıp maliyeti olmayan ürünler (en çok satandan). Ürün formunda maliyeti girin; sonraki siparişlerden itibaren kullanılır, önceki siparişler "tahmini" olarak alınır.',
    missingCols: { product: 'Ürün', sku: 'SKU', quantity: 'Satılan adet' },
    missingNone: 'Bu dönemde satılan bütün ürünlerin maliyeti var.',
    coverage: 'Satış anı maliyeti: {{snapshot}} satır · sonradan alınan: {{late}} · bilinmeyen: {{missing}}',
  },
  stockReport: {
    navLabel: 'Stok raporu',
    warehouse: 'Depo',
    allWarehouses: 'Bütün depolar',
    slowDays: 'Yavaş hareket eşiği',
    slowDaysOption: '{{days}} gün satış yok',
    tilesTitle: 'Stok özeti',
    tiles: {
      value: 'Stok değeri',
      units: 'Eldeki adet',
      turnover: 'Devir hızı (dönem)',
      daysOfInventory: 'Stokta kalma süresi',
      slow: 'Yavaş hareket eden stok',
    },
    unitsSub: '{{count}} varyant stokta',
    valueSub: 'Güncel maliyetle, KDV hariç',
    unknownCostSub: '{{count}} adedin maliyeti bilinmiyor',
    turnoverValue: '{{x}} kez',
    turnoverSub: 'Satılan {{sold}} adet · ortalama stok {{avg}} adet',
    daysValue: '{{days}} gün',
    noSales: 'Dönemde satış yok',
    slowSub: '{{count}} varyant · {{units}} adet',
    costHidden:
      'Maliyet görme yetkiniz olmadığı için stok değeri ve maliyet sütunları gösterilmez; adetler ve devir hızı tamdır.',
    method:
      'Stok değeri = eldeki adet × ürünün güncel maliyeti (KDV hariç; döviz maliyet son TCMB döviz alış kuruyla). Ürün maliyeti mal kabulde hareketli ağırlıklı ortalamayla güncellenir.',
    negative: '{{count}} adet eksi bakiye var (girişi yapılmadan satılmış stok); değere katılmadı.',
    fxMissing: '{{count}} varyantın döviz maliyeti için kur bulunamadı; değere katılmadı.',
    alertsTitle: 'Dikkat gerektiren stok',
    alerts: {
      expired: "SKT'si geçmiş",
      expiring: "{{days}} gün içinde SKT'si dolacak",
      critical: 'Kritik stok eşiğinde veya altında',
    },
    alertUnits: '{{units}} adet',
    alertVariants: '{{count}} varyant',
    goStock: 'Stok ekranında aç',
    warehousesTitle: 'Depo bazlı stok',
    warehouseCols: {
      warehouse: 'Depo',
      variants: 'Varyant',
      units: 'Eldeki adet',
      value: 'Stok değeri',
      unknown: 'Maliyetsiz adet',
    },
    inactive: 'pasif',
    categoriesTitle: 'Kategoriye göre stok',
    categoryNote:
      'Birden çok kategorideki ürün her birinde sayılır; satırların toplamı genel toplamı aşabilir.',
    categoryCols: {
      category: 'Kategori',
      units: 'Eldeki adet',
      value: 'Stok değeri',
      sold: 'Dönemde satılan',
    },
    variantsTitle: 'Varyant bazlı stok ve devir',
    slowTitle: 'Yavaş hareket eden ürünler',
    slowLead: 'Eldeki adedi olan ve son {{days}} gündür satılmayan varyantlar (stok değerine göre).',
    slowNone: 'Yavaş hareket eden ürün yok.',
    variantCols: {
      product: 'Ürün',
      onHand: 'Eldeki',
      available: 'Satılabilir',
      unitCost: 'Birim maliyet',
      value: 'Stok değeri',
      sold: 'Dönemde satılan',
      turnover: 'Devir',
      cover: 'Yeterlilik',
      lastSale: 'Son satış',
    },
    noCost: 'maliyet yok',
    uncategorized: 'Kategorisiz',
    never: 'Hiç satılmadı',
    showing:
      'Stok değerine göre ilk {{shown}} / {{total}} varyant gösteriliyor; indirilen dosyada hepsi var.',
    empty: 'Stokta ürün yok.',
  },
  purchasing: {
    navSuppliers: 'Tedarikçiler',
    navOrders: 'Satın alma',
    navReceive: 'Mal kabul',
    statuses: {
      requested: 'Talep',
      ordered: 'Sipariş verildi',
      partially_received: 'Kısmen alındı',
      received: 'Tamamı alındı',
      closed: 'Kapatıldı',
      cancelled: 'İptal',
    },
    filters: { all: 'Bütün siparişler', open: 'Açık siparişler' },
    supplier: 'Tedarikçi',
    supplierStatus: { active: 'Etkin', inactive: 'Pasif' },
    addSupplier: 'Tedarikçi ekle',
    editSupplier: 'Tedarikçiyi düzenle',
    saveSupplier: 'Tedarikçiyi kaydet',
    supplierSaved: 'Tedarikçi kaydedildi.',
    fields: {
      name: 'Unvan',
      code: 'Kod',
      taxOffice: 'Vergi dairesi',
      taxNumber: 'Vergi / T.C. kimlik no',
      contactName: 'Yetkili kişi',
      email: 'E-posta',
      phone: 'Telefon',
      address: 'Adres',
      currency: 'Para birimi',
      paymentTermDays: 'Vade (gün)',
      leadTimeDays: 'Teslim süresi (gün)',
      note: 'Not',
      status: 'Durum',
    },
    supplierCols: {
      supplier: 'Tedarikçi',
      contact: 'İletişim',
      terms: 'Vade',
      balance: 'Bakiye',
      overdue: 'Vadesi geçen',
      status: 'Durum',
    },
    noSuppliers: 'Henüz tedarikçi yok',
    noSuppliersLead:
      'Mal aldığınız firmaları ekleyin; satın alma siparişi ve cari hesap tedarikçiye bağlanır.',
    termsDays: '{{days}} gün',
    cash: 'Peşin',
    performanceTitle: 'Tedarikçi performansı',
    performanceLead:
      'Dönemde tedarikçiye verilen siparişler üzerinden; alım tutarı dönemdeki mal kabullerden (KDV hariç).',
    perfCols: {
      supplier: 'Tedarikçi',
      orders: 'Sipariş',
      onTime: 'Zamanında teslim',
      fill: 'Karşılama',
      short: 'Eksik satır',
      over: 'Fazla satır',
      lead: 'Ort. teslim süresi',
      spend: 'Alım tutarı',
    },
    late: '{{count}} gecikmiş',
    // Cari
    ledgerTitle: 'Cari hesap',
    ledgerLead:
      'Artı tutar tedarikçiye borç, eksi tutar ödeme veya alacaktır. Mal kabul faturası kendiliğinden yazılır.',
    addEntry: 'Cari kaydı ekle',
    saveEntry: 'Kaydı kaydet',
    entrySaved: 'Cari kaydı eklendi.',
    reverse: 'Ters kayıt',
    reverseTitle: 'Kaydı ters kayıtla düzelt',
    reverseReason: 'Gerekçe',
    reverseSave: 'Ters kaydı oluştur',
    reversed: 'Ters kayıt oluşturuldu.',
    kinds: {
      opening: 'Açılış bakiyesi',
      invoice: 'Fatura (mal kabul)',
      payment: 'Ödeme',
      return: 'İade / alacak',
      adjustment: 'Düzeltme',
      reversal: 'Ters kayıt',
    },
    directions: { debit: 'Borç artır', credit: 'Borç azalt' },
    methods: {
      bank_transfer: 'Havale/EFT',
      cash: 'Nakit',
      cheque: 'Çek',
      note: 'Senet',
      card: 'Kart',
      other: 'Diğer',
    },
    entryFields: {
      kind: 'Kayıt türü',
      amount: 'Tutar',
      direction: 'Yön',
      date: 'Tarih',
      dueDate: 'Vade tarihi',
      method: 'Ödeme yöntemi',
      reference: 'Dekont / belge no',
      description: 'Açıklama',
    },
    ledgerCols: {
      date: 'Tarih',
      kind: 'Kayıt',
      description: 'Açıklama',
      due: 'Vade',
      amount: 'Tutar',
      balance: 'Bakiye',
    },
    noEntries: 'Cari kaydı yok.',
    balanceLine: 'Bakiye: {{amount}} · vadesi geçen: {{overdue}}',
    reversedMark: 'ters çevrildi',
    ordersOfSupplier: 'Bu tedarikçinin siparişleri',
    // Siparişler
    newOrder: 'Yeni satın alma talebi',
    noOrders: 'Satın alma siparişi yok',
    noOrdersLead:
      'Talep oluşturun; onaylayınca "Sipariş ver" ile tedarikçiye verilmiş sayılır, mal geldiğinde mal kabul yapılır.',
    orderCols: {
      number: 'No',
      supplier: 'Tedarikçi',
      warehouse: 'Depo',
      expected: 'Beklenen',
      status: 'Durum',
      progress: 'Alınan',
      total: 'Tutar (KDV dahil)',
    },
    progress: '{{received}} / {{ordered}}',
    warehouse: 'Teslim alınacak depo',
    expectedDate: 'Beklenen teslim tarihi',
    note: 'Not',
    linesTitle: 'Ürünler',
    addProduct: 'Ürün ekle',
    lineCols: {
      product: 'Ürün',
      quantity: 'Adet',
      received: 'Alınan',
      remaining: 'Kalan',
      unitCost: 'Birim maliyet (KDV hariç)',
      tax: 'KDV %',
      total: 'Tutar (KDV hariç)',
    },
    taxDefault: 'Ürünün KDV oranı',
    removeLine: 'Satırı kaldır',
    totals: { subtotal: 'Ara toplam (KDV hariç)', tax: 'KDV', total: 'Toplam (KDV dahil)' },
    createOrder: 'Talebi oluştur',
    saveOrder: 'Talebi kaydet',
    orderCreated: 'Satın alma talebi oluşturuldu.',
    orderSaved: 'Kaydedildi.',
    editLines: 'Talebi düzenle',
    placeOrder: 'Sipariş ver',
    placeConfirm:
      'Talep tedarikçiye verilmiş siparişe çevrilecek; satırlar artık değiştirilemez. Devam edilsin mi?',
    placed: 'Sipariş verildi olarak işaretlendi.',
    cancelOrder: 'Siparişi iptal et',
    cancelConfirm: 'Sipariş iptal edilecek. Mal kabul yapılmamış siparişler iptal edilebilir.',
    cancelled: 'Sipariş iptal edildi.',
    closeOrder: 'Siparişi kapat',
    closeConfirm: 'Kalan adetler beklenmeyecek; sipariş kapatılacak.',
    closed: 'Sipariş kapatıldı.',
    print: 'Yazdır',
    orderInfo: 'Sipariş bilgileri',
    requestedOn: 'Talep tarihi',
    orderedOn: 'Sipariş tarihi',
    noExpected: 'Belirtilmedi',
    changeDate: 'Tarihi değiştir',
    saveDate: 'Tarihi kaydet',
    receiptsTitle: 'Mal kabuller',
    noReceipts: 'Henüz mal kabul yok.',
    receiptLine: '{{number}} · {{date}} · {{count}} kalem',
    invoiceNo: 'Fatura / irsaliye no',
    lot: 'Lot {{lot}}',
    expiry: 'SKT {{date}}',
    pickSupplier: 'Tedarikçi seçin',
    pickWarehouse: 'Depo seçin',
    quantityInvalid: 'Adet 1 veya daha büyük bir tam sayı olmalı.',
    costInvalid: 'Tutar okunamadı (örnek: 120,50).',
    // Mal kabul
    receiveTitle: 'Mal kabul: {{number}}',
    receive: 'Mal kabul',
    receiveSave: 'Mal kabulü kaydet',
    received: 'Mal kabul kaydedildi; stok girişi yapıldı.',
    receiveLead:
      'Gelen adetleri girin; gelmeyen satırı 0 bırakın. Lotlu üründe lot numarası ve son kullanma tarihini yazın.',
    receivedOn: 'Teslim alma tarihi',
    receiveCols: {
      product: 'Ürün',
      remaining: 'Kalan',
      quantity: 'Gelen adet',
      lot: 'Lot no',
      expiry: 'Son kullanma',
      cost: 'Faturadaki birim maliyet',
    },
    acceptOver: 'Kalan adetten fazlasını kabul et (fazla teslim)',
    postInvoice: 'Tedarikçi carisine fatura yaz (KDV dahil, vadeli)',
    updateCost: 'Ürün maliyetini güncelle (hareketli ağırlıklı ortalama)',
    nothingToReceive: 'En az bir satıra adet girin.',
    receivableEmpty: 'Mal kabul bekleyen sipariş yok',
    receivableLead: 'Tedarikçiye verilmiş, tamamı alınmamış siparişler. Maliyetler bu ekranda gösterilmez.',
    receivableCols: {
      number: 'Sipariş',
      supplier: 'Tedarikçi',
      warehouse: 'Depo',
      expected: 'Beklenen',
      lines: 'Kalan',
    },
    remainingLines: '{{count}} kalem · {{units}} adet',
    overdueMark: 'gecikti',
    costUpdated: 'Maliyeti güncellenen ürün: {{count}}',
  },
  reportBuilder: {
    navLabel: 'Rapor oluşturucu',
    datasets: { orders: 'Siparişler', lines: 'Ürün satışları', stock: 'Stok (bugün)' },
    datasetLeads: {
      orders: 'Satış raporundaki sayılan siparişler; tutarlar TL, sipariş tarihine göre.',
      lines:
        'Sayılan siparişlerin satırları; KDV hariç, iade sipariş oranında düşülür; SMM satış anı maliyetiyle.',
      stock: 'Bugünkü stok bakiyesi; değer güncel maliyetle.',
    },
    metrics: {
      orders: 'Sipariş',
      cancelledOrders: 'İptal edilen sipariş',
      grossSales: 'Sipariş tutarı',
      deductions: 'İade ve iptal',
      netSales: 'Net satış',
      netSalesExVat: 'Net satış (KDV hariç)',
      shipping: 'Kargo',
      items: 'Satılan adet',
      newCustomers: 'Yeni müşteri',
      averageOrder: 'Ortalama sepet',
      quantity: 'Adet',
      cogs: 'SMM',
      grossProfit: 'Brüt kâr',
      unknownCostSales: 'Maliyeti bilinmeyen satış',
      marginBps: 'Brüt marj',
      onHand: 'Eldeki',
      reserved: 'Ayrılmış',
      available: 'Satılabilir',
      stockValue: 'Stok değeri',
      unknownCostUnits: 'Maliyetsiz adet',
    },
    dims: {
      day: 'Gün',
      week: 'Hafta',
      month: 'Ay',
      year: 'Yıl',
      store: 'Mağaza',
      channel: 'Kanal',
      segment: 'Müşteri türü',
      paymentMethod: 'Ödeme yöntemi',
      country: 'Ülke',
      city: 'Şehir',
      customerType: 'Yeni / tekrar',
      product: 'Ürün',
      variant: 'SKU',
      category: 'Kategori',
      brand: 'Marka',
      warehouse: 'Depo',
      expiryMonth: 'SKT ayı',
    },
    customerTypes: { new: 'Yeni müşteri', returning: 'Tekrar eden' },
    dataset: 'Veri kümesi',
    metricsLabel: 'Metrikler (en çok 4)',
    row1: 'Satır boyutu',
    row2: 'İkinci satır boyutu',
    column: 'Sütun boyutu (pivot)',
    none: 'Yok',
    filtersTitle: 'Süzgeçler',
    warehouse: 'Depo',
    category: 'Kategori',
    brand: 'Marka',
    all: 'Tümü',
    sort: 'Sıralama',
    sortAuto: 'Otomatik',
    sortDesc: '{{metric}} (büyükten küçüğe)',
    sortAsc: '{{metric}} (küçükten büyüğe)',
    limit: 'En çok satır',
    run: 'Çalıştır',
    resultTitle: 'Sonuç',
    total: 'Toplam',
    empty: 'Bu seçimle veri yok.',
    hidden: 'Maliyet görme yetkiniz olmadığı için boş: {{names}}',
    multiValued:
      'Birden çok kategorideki ürün her kategoride sayılır; satırların toplamı genel toplamı aşabilir.',
    truncatedRows:
      'İlk {{shown}} / {{total}} satır gösteriliyor; dosyada da aynı satırlar var. Sınırı artırabilirsiniz.',
    truncatedColumns: 'İlk 36 sütun gösteriliyor.',
    fxMissing: 'Kuru bulunamayan {{count}} kayıt hesaba katılmadı.',
    pivotOneMetric: 'Sütun boyutu seçildiğinde yalnızca ilk metrik gösterilir.',
    chartTitle: '{{metric}} — {{dim}}',
    savedTitle: 'Kayıtlı raporlar',
    savedEmpty: 'Kayıtlı rapor yok.',
    sharedBy: 'Paylaşan: {{name}}',
    mine: 'Benim',
    sharedMark: 'Paylaşılan',
    open: 'Aç',
    current: 'Açık rapor: {{name}}',
    newReport: 'Yeni rapor',
    save: 'Raporu kaydet',
    saveChanges: 'Değişiklikleri kaydet',
    saveAs: 'Yeni rapor olarak kaydet',
    saveTitle: 'Raporu kaydet',
    name: 'Rapor adı',
    description: 'Açıklama',
    visibility: 'Görünürlük',
    visibilities: { private: 'Yalnızca ben', shared: 'Paylaşılan' },
    shareRoles: 'Rollere paylaş',
    shareUsers: 'Kişilere paylaş',
    shareNote:
      'Paylaşılan kişi veriyi kendi yetkileriyle görür: mağaza kapsamı ve maliyet görme yetkisi uygulanır.',
    saved: 'Rapor kaydedildi.',
    deleteReport: 'Raporu sil',
    deleteConfirm: 'Kayıtlı rapor silinecek. Paylaşılan kişiler de artık göremez.',
    deleted: 'Rapor silindi.',
    readOnly: 'Bu rapor sizinle paylaşıldı; değişiklikleri yeni rapor olarak kaydedebilirsiniz.',
    background: 'Arka planda hazırla',
    backgroundQueued: 'Dosya hazırlanıyor; "Rapor dosyalarım" sayfasından indirebilirsiniz.',
    openFiles: 'Rapor dosyalarım',
    schedule: 'Zamanla',
  },
  reportWidgets: {
    title: 'Rapor bileşenlerim',
    empty:
      'Ana panelinizde rapor bileşeni yok. Rapor oluşturucuda kaydettiğiniz veya sizinle paylaşılan bir raporu açıp "Ana panele ekle" ile buraya getirin.',
    goBuilder: 'Rapor oluşturucuya git',
    addToDashboard: 'Ana panele ekle',
    added: 'Rapor ana panele eklendi.',
    onDashboard: 'Ana panelde',
    display: 'Görünüm',
    size: 'Genişlik',
    displays: { table: 'Tablo', chart: 'Grafik', number: 'Yalnızca toplam' },
    sizes: { half: 'Yarım', full: 'Tam' },
    moveUp: 'Yukarı taşı: {{name}}',
    moveDown: 'Aşağı taşı: {{name}}',
    remove: 'Kaldır: {{name}}',
    removed: 'Bileşen kaldırıldı.',
    unavailable: 'Bu rapor artık sizinle paylaşılmıyor veya silindi.',
    unavailableTitle: 'Erişilemeyen rapor',
    openReport: 'Raporu aç',
    moreRows: '{{count}} satır daha raporda',
    chartUnavailable: 'Grafik için tek satır boyutu ve sütunsuz rapor gerekir; tablo gösteriliyor.',
    settings: 'Bileşen ayarları: {{name}}',
  },
  reportFiles: {
    navLabel: 'Rapor dosyalarım',
    filesTitle: 'Dosyalarım',
    filesEmpty:
      'Henüz dosya yok. Rapor oluşturucuda "Arka planda hazırla" ile büyük bir raporu isteyin veya zamanlanmış rapor kurun.',
    name: 'Rapor',
    format: 'Biçim',
    status: 'Durum',
    rows: 'Satır',
    size: 'Boyut',
    created: 'İstendi',
    expires: 'Silinme',
    source: 'Kaynak',
    sources: { manual: 'İstek', schedule: 'Zamanlanmış', workflow: 'Otomasyon akışı' },
    statuses: { queued: 'Sırada', running: 'Hazırlanıyor', done: 'Hazır', failed: 'Hazırlanamadı' },
    download: 'İndir',
    downloadNamed: 'İndir: {{name}}',
    failedGeneric: 'Dosya üretilemedi; yeniden isteyin.',
    keepNote:
      'Dosyalar sizin yetkilerinizle üretilir, yalnızca size görünür ve 30 gün sonra silinir. En çok 50.000 satır.',
    kb: '{{n}} KB',
    schedulesTitle: 'Zamanlanmış raporlar',
    schedulesEmpty: 'Zamanlanmış rapor yok.',
    newSchedule: 'Yeni zamanlama',
    report: 'Kayıtlı rapor',
    pickReport: 'Rapor seçin',
    noSavedReports: 'Önce rapor oluşturucuda bir rapor kaydedin.',
    frequency: 'Sıklık',
    frequencies: { daily: 'Günlük', weekly: 'Haftalık', monthly: 'Aylık' },
    weekday: 'Gün',
    weekdays: {
      '1': 'Pazartesi',
      '2': 'Salı',
      '3': 'Çarşamba',
      '4': 'Perşembe',
      '5': 'Cuma',
      '6': 'Cumartesi',
      '7': 'Pazar',
    },
    weekdaysInline: {
      '1': 'pazartesi',
      '2': 'salı',
      '3': 'çarşamba',
      '4': 'perşembe',
      '5': 'cuma',
      '6': 'cumartesi',
      '7': 'pazar',
    },
    monthDay: 'Ayın günü',
    hour: 'Saat (Türkiye)',
    when: {
      daily: 'Her gün {{hour}}',
      weekly: 'Her {{day}} {{hour}}',
      monthly: 'Her ayın {{day}}. günü {{hour}}',
    },
    periodNote: {
      daily: 'Önceki günün raporu gönderilir.',
      weekly: 'Önceki haftanın (pazartesi–pazar) raporu gönderilir.',
      monthly: 'Önceki ayın raporu gönderilir.',
    },
    recipients: 'Alıcılar',
    recipientCount: '{{count}} alıcı',
    enabled: 'Gönderim açık',
    enabledNamed: 'Gönderim: {{name}}',
    on: 'Açık',
    off: 'Kapalı',
    nextRun: 'Sonraki gönderim',
    lastDelivery: 'Son gönderim',
    never: 'Henüz yok',
    deliveryStatuses: {
      running: 'Gönderiliyor',
      sent: 'Gönderildi',
      partial: 'Kısmen',
      failed: 'Gönderilemedi',
    },
    deliveryCounts: '{{sent}} gönderildi · {{skipped}} atlandı',
    edit: 'Düzenle',
    editNamed: 'Düzenle: {{name}}',
    deleteNamed: 'Sil: {{name}}',
    deleteConfirm: 'Zamanlama silinecek. Daha önce üretilen dosyalar süresi dolana kadar kalır.',
    deleted: 'Zamanlama silindi.',
    saved: 'Zamanlama kaydedildi.',
    dialogNew: 'Raporu zamanla',
    dialogEdit: 'Zamanlamayı düzenle',
    deliveryNote:
      'E-postada rapor verisi olmaz, yalnızca bu sayfanın bağlantısı olur. Her alıcının dosyası kendi yetkileriyle üretilir; raporu göremeyen alıcı atlanır. Zamanlama kaydedildiğinde kapalıdır; gönderimi açtığınızda başlar.',
    unknownReport: 'Erişilemeyen rapor',
  },
  disputes: {
    navLabel: 'Ödeme itirazları',
    newDispute: 'Yeni itiraz',
    statusFilter: 'Durum',
    filters: { active: 'Açık olanlar', closed: 'Kapananlar', all: 'Tümü' },
    empty: 'Kayıtlı ödeme itirazı yok.',
    emptyActive: 'Açık ödeme itirazı yok.',
    tableTitle: 'Ödeme itirazları',
    cols: {
      number: 'İtiraz no',
      order: 'Sipariş',
      kind: 'Tür',
      status: 'Durum',
      amount: 'Tutar',
      fee: 'Ücret',
      opened: 'Açılış',
      due: 'Yanıt son günü',
      closed: 'Kapanış',
    },
    kinds: { chargeback: 'Ters ibraz', inquiry: 'Bilgi/belge talebi' },
    statuses: {
      open: 'Açık',
      evidence_submitted: 'Belge gönderildi',
      won: 'Kazanıldı',
      lost: 'Kaybedildi',
      accepted: 'Kabul edildi',
    },
    providers: { iyzico: 'iyzico', paytr: 'PayTR', manual: 'Fiziki POS / elle' },
    overdue: 'Süresi geçti',
    dueSoon: 'Süre doluyor',
    summary: '{{count}} açık itiraz. Risk altındaki tutar finans raporunda görünür.',
    dialogTitle: 'Ödeme itirazı aç',
    orderNumber: 'Sipariş numarası',
    findPayments: 'Ödemeleri bul',
    noPayments:
      'Bu siparişte itiraz açılabilecek ödeme yok. İtiraz yalnızca kartla veya fiziki POS ile alınmış ödemeye açılır.',
    payment: 'Ödeme',
    paymentOption: '{{provider}} · {{amount}} · {{date}}',
    alreadyDisputed: 'İtirazdaki tutar: {{amount}}',
    kind: 'Tür',
    caseNumber: 'Banka/kuruluş dosya numarası',
    reasonCode: 'Neden kodu',
    reason: 'Neden',
    amount: 'İtiraz tutarı',
    fee: 'İtiraz ücreti',
    openedOn: 'Bildirim tarihi',
    responseDueOn: 'Yanıt son günü',
    note: 'Not',
    amountInvalid: 'Tutar okunamadı.',
    created: 'İtiraz kaydı açıldı.',
    saved: 'İtiraz güncellendi.',
    providerNote:
      'Kayıt panelde tutulur; banka veya ödeme kuruluşuna bildirim gitmez. Yanıtı ve belgeleri kuruluşun kendi panelinden gönderin.',
    detailTitle: 'İtiraz {{number}}',
    back: 'Ödeme itirazları',
    infoTitle: 'Bilgiler',
    order: 'Sipariş',
    paymentInfo: 'Ödeme',
    paymentLine: '{{provider}} · {{amount}}',
    refunded: 'İade edilen: {{amount}}',
    actionsTitle: 'Durum',
    moveTo: {
      evidence_submitted: 'Belge gönderildi olarak işaretle',
      won: 'Kazanıldı',
      lost: 'Kaybedildi',
      accepted: 'Kabul et (itiraz etme)',
      open: 'Yeniden aç',
    },
    statusDialog: 'Durumu değiştir: {{status}}',
    closedOn: 'Kapanış tarihi',
    statusNote: 'Açıklama',
    reopenNote: 'Yeniden açma gerekçesi (ör. tahkim) zorunludur.',
    lossNote:
      'Kaybedilen veya kabul edilen tutar finans raporunda kârdan (siparişin dönemi) ve nakitten (kapanış günü) düşülür.',
    statusChanged: 'Durum değişti.',
    edit: 'Düzelt',
    editTitle: 'İtirazı düzelt',
    documentsTitle: 'Belgeler',
    noDocuments: 'Belge eklenmedi.',
    upload: 'Belge ekle',
    uploadHint: 'PDF, JPEG veya PNG; en fazla 10 MB. Belgeler yalnızca panelde görünür.',
    uploaded: 'Belge eklendi.',
    downloadNamed: 'İndir: {{name}}',
    notesTitle: 'Not ekle',
    addNote: 'Notu ekle',
    noteAdded: 'Not eklendi.',
    historyTitle: 'Geçmiş',
    events: {
      created: 'Kayıt açıldı',
      status: 'Durum: {{from}} → {{to}}',
      updated: 'Bilgiler düzeltildi',
      note: 'Not',
      document: 'Belge eklendi: {{name}}',
    },
    by: '{{name}}',
    system: 'Sistem',
  },
  priceSimulation: {
    navLabel: 'Fiyat simülasyonu',
    priceList: 'Fiyat listesi (TL)',
    category: 'Kategori',
    brand: 'Marka',
    days: 'Satış adedi dönemi',
    lastDays: 'Son {{count}} gün',
    priceChange: 'Fiyat değişikliği (%)',
    costChange: 'Maliyet değişikliği (%)',
    feeRate: 'Komisyon oranı (%)',
    feeDefault: 'boşsa dönemin etkin oranı',
    minMargin: 'En düşük marj (%)',
    percentInvalid: 'Yüzde okunamadı (ör. 10, -5, 2,5).',
    run: 'Hesapla',
    noWrite: 'Fiyatlar değişmez; yalnızca hesaplanır.',
    noLists: 'TL fiyat listesi yok.',
    summary: 'Simülasyon özeti',
    currentContribution: 'Dönem katkısı (mevcut)',
    scenarioContribution: 'Dönem katkısı (senaryo)',
    periodOf: '{{from}} – {{to}} satış adediyle',
    changeOf: 'Fark: {{amount}}',
    feeUsed: 'Senaryodaki komisyon',
    feeCurrent: 'Dönemin etkin oranı {{pct}} ({{count}} ödeme)',
    feeNone: 'Dönemde ödeme yok; etkin oran %0 sayıldı.',
    warnings: 'Uyarılı ürün',
    warningsOf: '{{negative}} zararda · {{low}} en düşük marjın altında',
    assumption:
      'Katkı = KDV hariç fiyat − maliyet − komisyon. Satış adedinin fiyattan etkilenmediği varsayılır; kargo ve reklam birim başına dağıtılmaz.',
    noCost: 'Maliyeti girilmemiş {{count}} ürün hesaba katılmadı.',
    feeUnknown: '{{count}} kart ödemesi için komisyon kuralı yok; etkin oran olduğundan düşük olabilir.',
    unitsHidden: 'Satış adedi için satış raporu yetkisi gerekir; dönem etkisi hesaplanmadı.',
    truncated: 'İlk {{count}} ürün gösteriliyor (uyarılılar önce).',
    tableTitle: 'Ürünlere göre birim ekonomi (mevcut → senaryo)',
    empty: 'Seçime uyan, fiyatı ve maliyeti olan ürün yok.',
    cols: {
      product: 'Ürün',
      units: 'Satılan adet',
      price: 'Fiyat',
      net: 'KDV hariç',
      cost: 'Maliyet',
      fee: 'Komisyon',
      contribution: 'Birim katkı',
      margin: 'Marj',
    },
    loss: 'Zarar',
    low: 'Marj düşük',
    goBulk: 'Fiyatları uygulamak için toplu fiyat düzenlemeye git',
  },
  marketingSummary: {
    navLabel: 'Pazarlama ve SEO özeti',
    funnelTitle: 'Vitrin hunisi (sunucu kaydı)',
    funnel: { carts: 'Sepete ürün eklendi', checkouts: 'Sipariş adımı', orders: 'Kesinleşen sipariş' },
    stepRate: 'Önceki adımdan: {{pct}}',
    funnelOverall: 'Sepetten kesinleşen siparişe: {{pct}}.',
    funnelNote:
      'Ürün görüntüleme sunucuda tutulmaz (GA4’te, çerez onayıyla). Sipariş adımı ödeme bekleyen ve başarısız ödemeleri de içerir. Aynı ziyaretçi birden çok sepet açmış olabilir.',
    customersTitle: 'Müşteri edinme ve değer',
    newCustomers: 'Yeni müşteri',
    returning: 'Tekrar eden: {{count}}',
    cac: 'Yeni müşteri başı reklam maliyeti (CAC)',
    cacOf: 'Reklam harcaması: {{spend}}',
    cacHidden: 'Reklam verisi işletme genelidir; mağaza süzgecinde veya reklam yetkisi olmadan gösterilmez.',
    noAds: 'Reklam hesabı bağlı değil.',
    value12m: '12 aylık müşteri değeri',
    value12mOf: 'Son 12 ayda {{customers}} müşteri · müşteri başı {{orders}} sipariş',
    valueToCac: 'Müşteri değeri ÷ CAC',
    valueToCacNote: '12 aylık geçmiş değer; tahmin değildir.',
    adsTitle: 'Reklam',
    adSpend: 'Harcama',
    clicks: 'Tıklama',
    ctr: 'Tıklama oranı',
    cpc: 'Tıklama başı maliyet',
    openAds: 'Reklam merkezini aç',
    seoTitle: 'Organik arama (Search Console)',
    seoNotLinked: 'Search Console bağlı değil.',
    organicClicks: 'Organik tıklama',
    impressions: 'Gösterim',
    position: 'Ortalama sıra',
    seoLast: 'Son veri günü: {{date}} (Search Console verisi 2–3 gün geriden gelir).',
    seoNoData: 'Bu dönem için eşitlenmiş veri yok.',
    messagingTitle: 'E-posta ve mesaj kampanyaları',
    channel: 'Kanal',
    sent: 'Gönderilen',
    delivered: 'Teslim edilen',
    clicked: 'Tıklayan',
    email: 'E-posta',
    channels: { sms: 'SMS', whatsapp: 'WhatsApp' },
    sourcesTitle: 'Siparişlerin son dokunuş kaynağı (vitrin)',
    sourcesEmpty: 'Bu dönemde vitrin siparişi yok.',
    source: 'Kaynak / ortam',
    orders: 'Sipariş',
    share: 'Pay',
    sourceKinds: { direct: 'Doğrudan / bilinmiyor', no_consent: 'Çerez izni yok (kaynak bilinemez)' },
    openAttribution: 'Kaynak raporunu aç',
    fxMissing: 'Kuru bulunamayan {{count}} döviz sipariş satış rakamlarına katılmadı.',
  },
  multiTouch: {
    navLabel: 'Çok dokunuşlu atribüsyon',
    dimension: 'Kırılım',
    dimensions: { source_medium: 'Kaynak / ortam', campaign: 'Kampanya' },
    summary: 'Atribüsyon özeti',
    orders: 'Kesinleşen vitrin siparişi',
    attributed: 'Kaynağı bilinen sipariş',
    attributedOf: 'Çerez izni olan ve en az bir teması olan',
    withPath: 'Ara teması kayıtlı sipariş',
    withPathOf: 'Ara temaslar bu özellik devreye girdikten sonra kaydedilir',
    avgTouches: 'Sipariş başına ortalama temas',
    tableTitle: 'Modellere göre sipariş payı ve net satış',
    models: { first: 'İlk temas', last: 'Son temas', linear: 'Doğrusal', position: 'Konuma göre (U)' },
    orderShare: 'Sipariş',
    revenue: 'Net satış',
    kinds: { direct: 'Doğrudan / temas yok', no_consent: 'Çerez izni yok (kaynak bilinemez)' },
    noCampaign: 'Kampanya yok',
    empty: 'Bu dönemde kesinleşen vitrin siparişi yok.',
    note: 'Doğrusal: her temasa eşit pay. Konuma göre (U): ilk ve son temasa %40, ara temaslara toplam %20 (iki temasta %50/%50). Sipariş payları ve net satış (KDV dahil, iade ve iptal düşülmüş) kalansız dağıtılır.',
    pathNote:
      'Art arda aynı kaynaktan gelişler tek temas sayılır; en çok 5 ara temas tutulur. Ara temaslar bu özellikten sonra verilen siparişlerde vardır; öncekilerde doğrusal ve U modeli yalnızca ilk ve son temasla hesaplanır.',
    fxMissing: 'Kuru bulunamayan {{count}} döviz sipariş rapora katılmadı.',
  },
  workflows: {
    navLabel: 'Otomasyon akışları',
    lead: 'Bir olay olduğunda (yeni ürün, ödenen sipariş, kritik stok, dönem sonu…) koşullara bakıp eylemleri kendiliğinden yapan akışlar. Akış açıldığı andan sonraki olayları işler; eylemler akışı açan kişinin güncel yetkisiyle çalışır ve her adım kayda geçer. Müşteriye giden iletiler (sepet hatırlatma, stok bildirimi) izin ve İYS denetimli kendi bölümlerinde kalır.',
    newFlow: 'Yeni akış',
    newFlowName: 'Yeni akış',
    pauseAll: 'Tümünü durdur',
    pauseAllConfirm: 'Açık bütün akışlar durdurulur ve bekleyen çalışmalar iptal edilir. Emin misiniz?',
    pausedAll: '{{count}} akış durduruldu.',
    autoPausedAlert: '{{count}} akış kendiliğinden durdu; nedenini giderip yeniden açın:',
    flowsTitle: 'Akışlar',
    summaryLine: '{{total}} akıştan {{active}} tanesi açık · son 7 günde {{failed}} başarısız çalışma',
    flowsEmpty: 'Henüz akış yok. Aşağıdaki hazır örneklerden biriyle başlayabilirsiniz.',
    columns: {
      name: 'Akış',
      chain: 'Tetikleyici → eylemler',
      status: 'Durum',
      runs: 'Son 7 gün',
      last: 'Son çalışma',
    },
    runAsShort: 'Açan: {{name}}',
    runsCounts: '{{succeeded}} başarılı · {{failed}} başarısız · {{pending}} bekleyen',
    never: 'Henüz çalışmadı',
    next: 'Sıradaki çalışma: {{date}}',
    statuses: { draft: 'Taslak', active: 'Açık', paused: 'Durdurulmuş', archived: 'Arşivde' },
    pausedReasons: {
      manual: 'Elle durduruldu.',
      rate_limited: 'Saatlik çalışma sınırı aşıldığı için kendiliğinden durdu.',
      owner_inactive: 'Akışı açan kişinin üyeliği kapandığı için kendiliğinden durdu.',
      owner_permission: 'Akışı açan kişinin yetkisi yetmediği için kendiliğinden durdu.',
    },
    templatesTitle: 'Hazır örnekler',
    useTemplate: 'Bu örnekle başla',
    useTemplateNamed: '"{{name}}" örneğiyle başla',
    linked: 'Müşteri iletisi — kendi bölümünde',
    linkedOn: 'Açık',
    linkedOff: 'Kapalı',
    openLinked: 'Ayarına git',
    templates: {
      new_product_seo_merchant: {
        name: 'Yeni ürün → SEO kontrolü → Merchant Center',
        text: 'Yeni ürün eklendiğinde SEO kurallarına bakar (başlık, açıklama, görsel, barkod); sorun yoksa mağazanın ürünlerini Merchant Center ile eşitler, sorun varsa durur ve kayda yazar.',
      },
      price_change_feed_log: {
        name: 'Fiyat değişti → Feed güncelle → Değişiklik kaydı',
        text: 'Fiyat değişince mağazanın ürünlerini Merchant Center ile eşitler ve olayı denetim kaydına yazar. Sık değişikliklerde 15 dakikada bir çalışır.',
      },
      critical_stock_notify: {
        name: 'Stok kritik → Yönetici bildirimi',
        text: 'Bir varyant kritik stok eşiğine düştüğünde stok yetkisi olan ekibe e-posta gönderir. Eşik altında kaldıkça tekrar göndermez; yenilenip yeniden düşerse yine bildirir.',
      },
      restock_customers: {
        name: 'Stok yenilendi → İzinli müşterilere bildirim',
        text: '"Gelince haber ver" talebi bırakan müşterilere ürün stoğa girince e-posta gider (talep izindir; engel listesi ve sıra uygulanır). Bu ileti Stok ve fiyat bildirimleri bölümünden yönetilir.',
      },
      paid_order_flow: {
        name: 'Sipariş ödendi → Hazırlık → Fatura ve kargo',
        text: 'Ödemesi alınan siparişi "hazırlanıyor"a alır (stok sipariş verilirken ayrılmıştır), BizimHesap fatura taslağını açar ve kargo yetkisi olan ekibe hazırlık e-postası gönderir.',
      },
      cart_reminder: {
        name: 'Sepet terk edildi → İzin kontrolü → Hatırlatma',
        text: 'Pazarlama otomasyonlarındaki "Terk edilen sepet" akışı gönderir: pazarlama izni, İYS, engel listesi, sıklık sınırı ve sessiz saat her e-postadan önce denetlenir.',
      },
      approved_post_schedule: {
        name: 'Yeni makale onaylandı → Zamanlı yayın',
        text: "Uzman onayı verilen makaleyi ertesi gün 10:00'da yayına zamanlar. Onaydan sonra metin değiştiyse yayımlamaz (onay geçersizdir).",
      },
      weekly_sales_report: {
        name: 'Haftalık dönem kapandı → Satış raporu → E-posta',
        text: 'Her pazartesi 08:00\'da geçen haftanın kayıtlı raporunu alıcıların kendi yetkisiyle üretir; e-postada yalnızca "Rapor dosyalarım" bağlantısı olur.',
      },
      tls_expiring_alert: {
        name: 'SSL süresi yaklaşıyor → Güvenlik uyarısı',
        text: 'Alan adının SSL sertifikası 14 günden az kaldığında veya hatalı olduğunda mağaza yöneticilerine uyarı gönderir; her sertifika için bir kez.',
      },
      payment_hook_failure: {
        name: 'POS bildirim hatası → Kritik bildirim',
        text: 'Ödeme kuruluşunun bildirimi (webhook) veya geri dönüşü reddedildiğinde ya da işlenemediğinde ödeme ayarı yetkisi olanlara kritik uyarı gönderir; en çok saatte bir.',
      },
    },
    recentRuns: 'Son çalışmalar',
    runsTitle: 'Çalışma kaydı',
    runsEmpty: 'Henüz çalışma yok.',
    runColumns: { event: 'Olay', status: 'Durum', progress: 'Eylem', when: 'Zaman' },
    runStatuses: {
      pending: 'Bekliyor',
      running: 'Çalışıyor',
      succeeded: 'Başarılı',
      failed: 'Başarısız',
      skipped: 'Atlandı',
      cancelled: 'İptal',
    },
    progress: '{{done}}/{{total}}',
    nextAttempt: 'Sonraki deneme: {{date}}',
    back: 'Otomasyon akışları',
    builderLegend: 'Akış tanımı',
    name: 'Akış adı',
    description: 'Açıklama',
    runAs: 'Akışı açan: {{name}} — eylemler bu kişinin güncel yetkileriyle çalışır.',
    activeEditNote:
      'Akış açık: kaydettiğiniz değişiklik yeni olaylara uygulanır ve akış bundan sonra sizin adınıza çalışır.',
    unsaved: 'Kaydedilmemiş değişiklik var.',
    problemsTitle: 'Akışı açmadan önce giderin',
    problemAction: 'Eylem {{n}}',
    problemRule: 'Koşul {{n}}',
    save: 'Kaydet',
    saved: 'Akış kaydedildi.',
    activate: 'Aç',
    activated: 'Akış açıldı; bundan sonraki olaylar işlenecek.',
    pause: 'Durdur',
    paused: 'Akış durduruldu.',
    archive: 'Arşivle',
    archiveConfirm: 'Akış arşivlenir ve bir daha açılamaz; çalışma kaydı korunur. Emin misiniz?',
    archived: 'Akış arşivlendi.',
    step1: 'Tetikleyici',
    step2: 'Koşullar',
    step3: 'Eylemler',
    trigger: 'Ne olduğunda?',
    triggers: {
      product_created: 'Yeni ürün eklendi',
      price_changed: 'Fiyat değişti',
      stock_critical: 'Stok kritik seviyeye düştü',
      payment_captured: 'Sipariş ödendi',
      post_approved: 'Makale uzman onayı aldı',
      schedule: 'Dönem kapandı (takvim)',
      tls_expiring: 'SSL sertifikası bitmek üzere',
      payment_webhook_failed: 'Ödeme (POS) bildirimi işlenemedi',
      integration_error: 'Bağlantı testi hata verdi',
    },
    triggerHints: {
      product_created: 'Panelden, içe aktarmayla veya kopyalamayla eklenen her yeni ürün bir olaydır.',
      price_changed:
        'Tek fiyat değişikliği, toplu fiyat işlemi (ve geri alması) ve kur güncellemesi bir olaydır.',
      stock_critical:
        'Stok raporundaki kritik stok kurallarıyla aynı: satılabilir adet eşiğe eşit veya altında. Listeye yeni giren varyant/depo bir olaydır; akış açılırken zaten kritik olanlar sayılmaz.',
      payment_captured: 'Kartla, POS ile veya "Ödeme alındı" ile tahsil edilen her ödeme bir olaydır.',
      post_approved: 'Sağlık içerikli yazıya veteriner/uzman onayı verildiğinde bir olaydır.',
      schedule:
        'Seçtiğiniz gün ve saatte (Türkiye) biten dönem için bir kez çalışır: dün, geçen hafta (pazartesi–pazar) veya geçen ay.',
      tls_expiring:
        'Alan adı denetimine göre sertifika süresi az kalan veya hatalı alan adı; her sertifika için bir olay.',
      payment_webhook_failed:
        'Ödeme kuruluşundan gelen bildirim veya geri dönüş reddedildiğinde (imza geçersiz vb.) ya da işlenemediğinde bir olaydır.',
      integration_error: 'Ayarlardaki bir bağlantı testi hata verdiğinde bir olaydır.',
    },
    frequencies: { daily: 'Günlük (dün)', weekly: 'Haftalık (geçen hafta)', monthly: 'Aylık (geçen ay)' },
    weekdays: {
      '1': 'Pazartesi',
      '2': 'Salı',
      '3': 'Çarşamba',
      '4': 'Perşembe',
      '5': 'Cuma',
      '6': 'Cumartesi',
      '7': 'Pazar',
    },
    noFields: 'Bu tetikleyicide koşul alanı yok; her olayda eylemler çalışır.',
    noConditions: 'Koşul yok: her olayda eylemler çalışır.',
    match: 'Koşullar',
    matches: { all: 'Hepsi tutsun', any: 'Biri tutsun yeter' },
    addRule: 'Koşul ekle',
    ruleN: 'Koşul {{n}}',
    removeRuleN: 'Koşul {{n}} kaldır',
    ruleField: 'Alan',
    ruleOp: 'Karşılaştırma',
    ruleValue: 'Değer',
    ruleValueMoney: 'Tutar (TL)',
    ruleResult: { true: 'tuttu', false: 'tutmadı' },
    fields: {
      title: 'Ad / başlık',
      status: 'Durum',
      variantCount: 'Varyant sayısı',
      brand: 'Marka',
      source: 'Değişiklik türü',
      priceList: 'Fiyat listesi',
      sku: 'Stok kodu',
      product: 'Ürün',
      available: 'Satılabilir adet',
      threshold: 'Eşik',
      warehouse: 'Depo',
      scope: 'Eşik türü',
      number: 'Sipariş no',
      amount: 'Tutar',
      currency: 'Para birimi',
      provider: 'Sağlayıcı',
      channel: 'Kanal',
      store: 'Mağaza',
      published: 'Onaylanan hâli yayında',
      host: 'Alan adı',
      daysLeft: 'Kalan gün',
      state: 'Durum',
      kind: 'Bildirim türü',
      outcome: 'Sonuç',
      message: 'İleti',
      environment: 'Ortam',
    },
    options: {
      draft: 'Taslak',
      active: 'Aktif',
      archived: 'Arşiv',
      single: 'Tek fiyat',
      bulk: 'Toplu işlem',
      revert: 'Toplu işlemin geri alınması',
      fx: 'Kur güncellemesi',
      warehouse: 'Depo eşiği',
      variant: 'Varyant eşiği',
      default: 'Varsayılan eşik',
      web: 'Vitrin',
      b2b: 'Bayi',
      manual: 'Panel',
      api: 'API',
      expiring: 'Bitmek üzere',
      error: 'Hatalı',
      webhook: 'Bildirim (webhook)',
      callback: 'Geri dönüş',
      rejected: 'Reddedildi',
      sandbox: 'Test',
      live: 'Canlı',
      yes: 'Evet',
      no: 'Hayır',
    },
    ops: {
      eq: 'eşittir',
      neq: 'eşit değildir',
      gt: 'büyüktür',
      gte: 'en az',
      lt: 'küçüktür',
      lte: 'en çok',
      contains: 'içerir',
      not_contains: 'içermez',
      is_true: 'evet',
      is_false: 'hayır',
    },
    actions: {
      notify_staff: 'Ekibe e-posta bildirimi',
      seo_check: 'SEO kontrolü',
      merchant_sync: 'Merchant Center ile eşitle (feed)',
      record: 'Değişiklik kaydı',
      order_processing: 'Siparişi "hazırlanıyor"a al',
      invoice_draft: 'Fatura taslağı (BizimHesap)',
      publish_post: 'Makaleyi yayımla veya zamanla',
      send_report: 'Kayıtlı raporu gönder',
    },
    actionHints: {
      notify_staff:
        'Yalnızca panel üyelerine (ekibe) gider; müşteriye ileti gönderilmez. E-postada akışın adı, olay ve çalışma kaydının bağlantısı vardır.',
      seo_check:
        'SEO Komuta Merkezi kurallarıyla ürünü denetler (ürün henüz yayında olmasa da). Sorunlar adım kaydında listelenir.',
      merchant_sync:
        'Seçilen mağazanın ürünleri Merchant Center\'a gönderilir (değişmeyenler tekrar gönderilmez). Google bağlantısı yoksa adım "kurulum gerekli" ile atlanır.',
      record: 'Olayı ve alanlarını denetim kaydına "otomasyon kaydı" olarak yazar.',
      order_processing:
        'Yalnızca "ödendi" durumundaki sipariş "hazırlanıyor"a alınır; ekip elle ilerlettiyse dokunulmaz. Stok sipariş verilirken ayrılmıştır, kargoya verilince düşülür.',
      invoice_draft:
        'Siparişin faturası yoksa BizimHesap taslağı açar. Gönderim açıksa e-Arşiv/e-Fatura oluşur; belirsiz veya reddedilen gönderim kendiliğinden yinelenmez.',
      publish_post:
        'Onaylanan yazıyı yayımlar veya ileri bir saate zamanlar. Onaydan sonra metin değiştiyse yayımlamaz.',
      send_report:
        'Dönemin kayıtlı raporunu her alıcının kendi yetkisiyle üretip "Rapor dosyalarım"a koyar; e-postada rapor verisi yoktur.',
    },
    actionN: 'Eylem {{n}}',
    addAction: 'Eylem ekle',
    moveUpN: 'Eylem {{n}} yukarı',
    moveDownN: 'Eylem {{n}} aşağı',
    removeActionN: 'Eylem {{n}} kaldır',
    notAllowed: '(yetkiniz yok)',
    incompatible: '(bu tetikleyicide kullanılamaz)',
    choose: 'Seçin',
    params: {
      days: 'Kaç gün kala',
      frequency: 'Sıklık',
      weekday: 'Gün',
      monthDay: 'Ayın günü',
      hour: 'Saat (Türkiye)',
      recipients: 'Kime',
      permission: 'Yetki',
      userIds: 'Kişiler',
      subject: 'E-posta konusu',
      message: 'İleti (isteğe bağlı)',
      stopOnIssues: 'SEO sorunu varsa sonraki eylemlere geçme',
      storeId: 'Mağaza',
      note: 'Kayıt notu (isteğe bağlı)',
      send: "Taslağı hemen BizimHesap'a gönder (e-Arşiv/e-Fatura oluşur)",
      mode: 'Ne zaman',
      hours: 'Kaç saat sonra',
      savedReportId: 'Kayıtlı rapor',
      format: 'Dosya biçimi',
      recipientIds: 'Alıcılar',
    },
    recipientsModes: { permission: 'Bu yetkiye sahip herkes', users: 'Seçtiğim kişiler' },
    placeholders: 'Metinde kullanılabilecek alanlar: {{list}}',
    publishModes: { now: 'Hemen', delay: 'Belirli saat sonra', next_day: 'Ertesi gün belirli saatte' },
    reportNone: 'Kayıtlı rapor yok; önce rapor oluşturucuda bir rapor kaydedin.',
    advanced: 'Sınırlar',
    throttle: 'Bir çalışmadan sonra bekleme (dakika)',
    throttleNote:
      '0 = yok. Gürültülü olaylarda tekrarı sınırlar; bu sürede gelen olaylar "atlandı" diye kaydedilir.',
    rate: 'Saatte en çok çalışma',
    rateNote: 'Aşılırsa akış kendiliğinden durur ve yöneticilere e-posta gider (döngü ve sel koruması).',
    test: 'Son olaylarla dene',
    testTitle: 'Deneme sonucu',
    testNote:
      'Tetikleyicinin son olaylarıyla koşullar değerlendirildi; hiçbir eylem çalışmadı, hiçbir kayıt değişmedi.',
    testEmpty: 'Bu tetikleyicide henüz olay yok.',
    matched: 'Koşul tutuyor — eylemler çalışırdı',
    notMatched: 'Koşul tutmuyor — atlanırdı',
    outOfScope: 'Mağaza kapsamınız dışında — atlanırdı',
    statusFilter: 'Durum',
    runTitle: 'Çalışma',
    triggerLabel: 'Tetikleyici',
    event: 'Olay',
    eventKey: 'Olay anahtarı',
    createdAt: 'Olay alındı',
    finishedAt: 'Bitti',
    reasonLabel: 'Neden',
    lastError: 'Son hata',
    attempts: 'Yeniden deneme',
    fieldsTitle: 'Olay alanları',
    conditionsTitle: 'Koşullar',
    stepsTitle: 'Adım kaydı',
    stepsEmpty: 'Henüz eylem çalışmadı.',
    remaining: 'Çalışmayan eylemler: {{list}}',
    outcomes: { succeeded: 'Başarılı', skipped: 'Atlandı', stopped: 'Akışı durdurdu', failed: 'Hata' },
    attempt: '{{n}}. deneme',
    reasons: {
      conditions_not_met: 'Koşul tutmadı.',
      throttled: 'Bekleme süresi dolmadan geldi.',
      store_scope: 'Akışı açan kişinin mağaza kapsamı dışında.',
      workflow_paused: 'Akış durduruldu.',
      workflow_archived: 'Akış arşivlendi.',
      manual: 'Elle iptal edildi.',
      manual_retry: 'Elle yeniden denendi.',
      stopped: 'Bir eylem akışı durdurdu',
    },
    codes: {
      not_configured: 'Kurulum gerekli: bağlantı yok veya eksik; adım atlandı.',
      internal_error: 'Geçici hata; yeniden denenir.',
      forbidden: 'Akışı açan kişinin bu işlem için yetkisi yok.',
      unknown: 'Hata kodu: {{code}}',
    },
    detail: {
      issues: 'SEO sorunları: {{list}}',
      recipients: '{{count}} kişiye gönderildi.',
      sent: '{{sent}} alıcıya gönderildi, {{skipped}} alıcı atlandı (yetkisi yok veya üyeliği kapalı).',
      publishAt: 'Yayın zamanı: {{date}}',
      publishedNow: 'Hemen yayımlandı.',
      merchant: 'Merchant Center: {{inserted}} gönderildi, {{deleted}} silindi, {{unchanged}} değişmedi.',
      orderStatus: 'Sipariş durumu: {{status}}',
      invoice: 'Fatura: {{status}}',
      permission: 'Gereken yetki: {{name}}',
    },
    invoiceStatuses: {
      draft: 'taslak açıldı',
      sending: 'gönderiliyor',
      sent: 'gönderildi',
      failed: 'gönderilemedi',
      uncertain: 'sonucu belirsiz',
      cancelled: 'iptal',
    },
    retry: 'Yeniden dene',
    retried: 'Çalışma yeniden sıraya alındı; kaldığı eylemden sürecek.',
    cancel: 'İptal et',
    cancelConfirm: 'Bekleyen çalışma iptal edilir ve eylemleri çalışmaz.',
    cancelledToast: 'Çalışma iptal edildi.',
  },
} as const;
